// removed by extract-text-webpack-plugin
module.exports = {"button":"OayRzABYgbJWvMfoY5TMu","disabled":"HYkzKG1GIK2ShxgpiMzA8","xs__smaller_text":"_2jGZlyupQZbRNlkIuzNZap","xs":"V-Rm6CJI75m5Is07d5F7J","sm":"_1AYmBtYCeHPN09hYqsIg4Q","md":"_1WxC3HvqG2zs194cUaNU3D","lg":"_1Y_pH0NTy59iuAAeiMqV7V","max":"_1vLnc_Mo2slt5TOWSw3Bx2","default":"PB8Re84gDvo6Q2W5PgSbh","success":"_4gpfFhRglf6btBuTPNAec","danger":"_1HS9-OV7SEqrcUiUFrBJUq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisButton.scss
// module id = 449
// module chunks = 0